import { render, staticRenderFns } from "./GanttChart.vue?vue&type=template&id=2f236f9c&scoped=true"
import script from "./GanttChart.vue?vue&type=script&lang=ts"
export * from "./GanttChart.vue?vue&type=script&lang=ts"
import style0 from "./GanttChart.vue?vue&type=style&index=0&id=2f236f9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f236f9c",
  null
  
)

export default component.exports